<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-07-31 16:42:17
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-08-01 09:42:15
 * @FilePath: \合联\oms\src\view\emergencyKit\tmsInbound\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/emergencyKit/tmsInbound";
export default {
  name: "tmsInbound",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("setBatch", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              account: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              password: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              awbnos: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { type: 24 },
            { account: 24 },
            { password: 24 },
            { awbnos: 24 },
          ],
          fields: [
            {
              name: () => this.$tz("账号"),
              key: "account",
              component: "Input",
              placeholder: () => this.$tz("账号"),
            },
            {
              name: () => this.$tz("密码"),
              key: "password",
              component: "Input",
              placeholder: () => this.$tz("密码"),
            },
            {
              name: this.$tz("类型"),
              key: "type",
              component: "Radio",
              options: [
                // 1提单 2运单
                {
                  label: this.$tz("提单"),
                  value: 1,
                },
                {
                  label: this.$tz("运单"),
                  value: 2,
                },
              ],
              optionsFn: "",
              optionsKey: "",
              default: 1,
              bind: {
                border: true,
              },
            },
            {
              key: "awbnos",
              name: () => this.$tz("订单号"),
              placeholder() {
                return this.$tz("订单号");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 },
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            name: this.$tz("状态"),
            key: "status",
            component: "Select",
            placeholder: () => this.$tz("状态"),
            options: [
              {
                label: this.$tz("待回调"),
                value: 0,
              },
              {
                label: this.$tz("成功"),
                value: 1,
              },
              {
                label: this.$tz("失败"),
                value: 2,
              },
            ],
            optionsFn: "",
            optionsKey: "",
            default: "",
          },
          {
            key: "awbno",
            placeholder() {
              return this.$tz("订单号");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("MAWB NO."),
          key: "extract_no",
          minWidth: 130,
        },
        {
          name: () => this.$t("Tracking number"),
          key: "shipment_no",
          minWidth: 130,
        },
        {
          name: () => this.$tz("推送,重量"),
          key: "weight",
          minWidth: 130,
        },
        {
          name: () => this.$tz("C,时间"),
          key: "ts",
          minWidth: 130,
        },

        {
          name: () => this.$tz("状态"),
          key: "status",
          minWidth: 130,
          methods: {
            render({ value }) {
              //  0待回调 1成功 2失败
              return value == 0
                ? this.$tz("待回调")
                : value == 1
                ? this.$tz("成功")
                : this.$tz("失败");
            },
          },
        },
        {
          name: () => this.$t("error_mes"),
          key: "msg",
          minWidth: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 160,
        },
        {
          name: () => this.$tz("精确,时间"),
          key: "c_time",
          minWidth: 160,
        },
        {
          name: () => this.$tz("区间,开始时间"),
          key: "c_time_begin",
          minWidth: 160,
        },
        {
          name: () => this.$tz("区间,开始时间"),
          key: "c_time_end",
          minWidth: 160,
        },
        {
          name: () => this.$t("accountNum"),
          key: "account",
          minWidth: 130,
        },
        {
          name: () => this.$tz("密码"),
          key: "password",
          minWidth: 130,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>